var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 137 128.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-5a2beaac-131a-4d6e-8617-f86327a99191 {\n        fill: url(#uuid-50541409-5f2e-466b-9ae6-12a1d9bfabc4);\n      }\n\n      .uuid-629b747b-ef9f-4ac6-973c-c0bb5801690b {\n        fill: url(#uuid-0ac77e78-a903-44e5-8218-bf079118a78b);\n      }\n\n      .uuid-e0139154-8e89-41d0-874d-7c8324459f7b {\n        fill: url(#uuid-e005a4c5-7395-49bb-b8d5-998bddc18e84);\n      }\n\n      .uuid-ed0a955d-382e-4ff8-b2c0-1c778ed44b1b {\n        fill: url(#uuid-56a8c673-1466-4b73-ad46-9f23514ba1b2);\n      }\n\n      .uuid-9a226985-a9bc-4adf-a632-a95384708062 {\n        fill: url(#uuid-afd8d168-4d6d-457b-84eb-1ccfee59ad9c);\n      }\n\n      .uuid-9f4b23d1-bcb3-4536-b5c1-7e7ee8655e1b {\n        fill: #0049b0;\n      }\n\n      .uuid-94151612-2c2d-468d-9072-250cdb79a48a {\n        fill: #00b8d9;\n      }\n\n      .uuid-db82ae0c-686e-42a4-9056-084dda6f1927 {\n        fill: #008da6;\n      }\n\n      .uuid-268b7b2d-4901-459b-9dbc-cc1ebae3ffa1 {\n        fill: #ffab00;\n      }\n\n      .uuid-6b0ee86a-9f5a-40a3-b7e4-e3b6c30f9cff {\n        fill: #8c715d;\n      }\n\n      .uuid-e9a07e71-0bdf-4476-825c-7cd97f117bf4 {\n        fill: #cecece;\n      }\n\n      .uuid-a2ae7cf7-2c43-4b66-b5df-bbaa33c3711f {\n        fill: #b19177;\n      }\n\n      .uuid-f122a09c-d39b-4d05-be77-f07a74b9d052 {\n        fill: #dfe1e5;\n      }\n\n      .uuid-8c69bd15-7a7b-4502-943c-487c3b63a79c {\n        fill: #d8e7f8;\n      }\n\n      .uuid-5e83a012-5090-4880-b44d-b4ef790f200c {\n        fill: #172b4d;\n      }\n\n      .uuid-0c3eb26d-7ad6-400a-9f6b-1f5a46848288 {\n        fill: #171f40;\n      }\n\n      .uuid-438bcb12-39f0-4a45-ae73-7af379dd8073 {\n        fill: #42526e;\n      }\n\n      .uuid-9cfc8472-3ca2-4ad9-86f1-1b2c15975810 {\n        fill: #72594b;\n      }\n\n      .uuid-0e17f164-b13e-47a1-9f14-de8c509ace33 {\n        fill: #543e36;\n      }\n\n      .uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce {\n        fill: #57d9a3;\n      }\n\n      .uuid-38a93395-3052-4fc2-913f-145c160e80d2 {\n        fill: #2684ff;\n      }\n\n      .uuid-88c1bb33-0f2c-442a-a134-e5a9c005e83d {\n        fill: url(#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e);\n      }\n\n      .uuid-5189cdc2-a78a-488a-948f-3050f409d558 {\n        fill: url(#uuid-e3aa08ee-ea45-4c68-945c-400a1b7ec42e);\n      }\n\n      .uuid-5189cdc2-a78a-488a-948f-3050f409d558, .uuid-4bd83080-2f23-40c8-ac71-478aeaba2dca {\n        isolation: isolate;\n        opacity: .1;\n      }\n\n      .uuid-f403781b-d90e-454f-87b6-ccb21e2f30fb {\n        fill: url(#uuid-c4a744ea-75bd-4c1f-95a0-72242f1eb374);\n      }\n\n      .uuid-231bf2bf-cc28-42d1-965d-b6122ecbeb0b {\n        fill: url(#uuid-d378a64c-eff2-42a2-9f39-f566f79bdb9f);\n      }\n\n      .uuid-2c4ee735-9a45-48a4-a787-5c70b6f239d0 {\n        fill: url(#uuid-e4e5379e-b62f-48a9-8671-2a79f7e8a779);\n      }\n\n      .uuid-7679e2f6-97b1-4862-aa1d-839b7ef5a1a4 {\n        fill: url(#uuid-8f18228c-ff92-43d7-b230-ed6ae04a1914);\n      }\n\n      .uuid-4bd83080-2f23-40c8-ac71-478aeaba2dca {\n        fill: url(#uuid-f332f851-4a3a-41c0-bd84-dce657c5ab62);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e",
    x1: 66.071,
    y1: 14.574,
    x2: 137,
    y2: 14.574,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b8d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-8f18228c-ff92-43d7-b230-ed6ae04a1914",
    y1: 23.319,
    y2: 23.319,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c4a744ea-75bd-4c1f-95a0-72242f1eb374",
    y1: 32.064,
    y2: 32.064,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e4e5379e-b62f-48a9-8671-2a79f7e8a779",
    y1: 40.809,
    y2: 40.809,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-afd8d168-4d6d-457b-84eb-1ccfee59ad9c",
    y1: 75.463,
    y2: 75.463,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0ac77e78-a903-44e5-8218-bf079118a78b",
    y1: 49.553,
    y2: 49.553,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-50541409-5f2e-466b-9ae6-12a1d9bfabc4",
    y1: 67.043,
    y2: 67.043,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-56a8c673-1466-4b73-ad46-9f23514ba1b2",
    y1: 58.298,
    y2: 58.298,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-d378a64c-eff2-42a2-9f39-f566f79bdb9f",
    y1: 83.884,
    y2: 83.884,
    xlinkHref: "#uuid-5a6918c3-4c7f-4eb4-84d3-bc3fd51f256e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f332f851-4a3a-41c0-bd84-dce657c5ab62",
    x1: 7.973,
    y1: 776.192,
    x2: 42.177,
    y2: 776.192,
    gradientTransform: "translate(0 -651)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#091e42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#091e42",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#091e42",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#091e42",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#091e42",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091e42",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e005a4c5-7395-49bb-b8d5-998bddc18e84",
    x1: -989.518,
    y1: 744.379,
    x2: -974.586,
    y2: 744.379,
    gradientTransform: "translate(-966 -651) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e3aa08ee-ea45-4c68-945c-400a1b7ec42e",
    x1: 89.937,
    y1: 774.592,
    x2: 124.141,
    y2: 774.592,
    xlinkHref: "#uuid-f332f851-4a3a-41c0-bd84-dce657c5ab62"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-8e4f5fda-8c98-48dc-aa5e-f75dec6f0654",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-88c1bb33-0f2c-442a-a134-e5a9c005e83d",
    x: 66.071,
    y: 11.012,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-7679e2f6-97b1-4862-aa1d-839b7ef5a1a4",
    x: 66.071,
    y: 19.757,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-f403781b-d90e-454f-87b6-ccb21e2f30fb",
    x: 66.071,
    y: 28.501,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-2c4ee735-9a45-48a4-a787-5c70b6f239d0",
    x: 66.071,
    y: 37.246,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-9a226985-a9bc-4adf-a632-a95384708062",
    x: 66.071,
    y: 71.901,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-629b747b-ef9f-4ac6-973c-c0bb5801690b",
    x: 66.071,
    y: 45.991,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-5a2beaac-131a-4d6e-8617-f86327a99191",
    x: 66.071,
    y: 63.48,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-ed0a955d-382e-4ff8-b2c0-1c778ed44b1b",
    x: 66.071,
    y: 54.735,
    width: 70.929,
    height: 7.125
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-231bf2bf-cc28-42d1-965d-b6122ecbeb0b",
    x: 66.071,
    y: 80.322,
    width: 70.929,
    height: 7.125
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-32a09604-ec80-4d56-84af-3fb4cee4fa33",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-a2d3615b-ae14-4e19-9c31-517e5471ebc1",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-8c69bd15-7a7b-4502-943c-487c3b63a79c",
    x: 20.404,
    y: 11.634,
    width: 19.109,
    height: 75.813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-268b7b2d-4901-459b-9dbc-cc1ebae3ffa1",
    x: 21.376,
    y: 38.891,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-268b7b2d-4901-459b-9dbc-cc1ebae3ffa1",
    x: 21.376,
    y: 12.964,
    width: 17.165,
    height: 4.986
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-268b7b2d-4901-459b-9dbc-cc1ebae3ffa1",
    x: 21.376,
    y: 32.243,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-268b7b2d-4901-459b-9dbc-cc1ebae3ffa1",
    x: 21.376,
    y: 25.595,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-268b7b2d-4901-459b-9dbc-cc1ebae3ffa1",
    x: 21.376,
    y: 18.947,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-8c69bd15-7a7b-4502-943c-487c3b63a79c",
    cx: 29.959,
    cy: 4.82,
    rx: 4.696,
    ry: 4.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-8c69bd15-7a7b-4502-943c-487c3b63a79c",
    y: 11.634,
    width: 19.109,
    height: 75.813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-e9a07e71-0bdf-4476-825c-7cd97f117bf4",
    x: 12.555,
    y: 54.443,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-38a93395-3052-4fc2-913f-145c160e80d2",
    x: 0.972,
    y: 38.891,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-38a93395-3052-4fc2-913f-145c160e80d2",
    x: 0.972,
    y: 45.54,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-268b7b2d-4901-459b-9dbc-cc1ebae3ffa1",
    x: 11.66,
    y: 53.517,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-38a93395-3052-4fc2-913f-145c160e80d2",
    x: 0.972,
    y: 12.964,
    width: 17.165,
    height: 4.986
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-38a93395-3052-4fc2-913f-145c160e80d2",
    x: 0.972,
    y: 32.243,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-38a93395-3052-4fc2-913f-145c160e80d2",
    x: 0.972,
    y: 25.595,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-38a93395-3052-4fc2-913f-145c160e80d2",
    x: 0.972,
    y: 18.947,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-8c69bd15-7a7b-4502-943c-487c3b63a79c",
    cx: 9.554,
    cy: 4.82,
    rx: 4.696,
    ry: 4.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-8c69bd15-7a7b-4502-943c-487c3b63a79c",
    x: 40.809,
    y: 11.634,
    width: 19.109,
    height: 75.813
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 38.891,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 12.964,
    width: 17.165,
    height: 4.986
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 32.243,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 25.595,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 18.947,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-8c69bd15-7a7b-4502-943c-487c3b63a79c",
    cx: 50.363,
    cy: 4.82,
    rx: 4.696,
    ry: 4.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 58.836,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 52.188,
    width: 16.842,
    height: 5.651
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1c109d06-f559-496f-a893-6ff77dfdb5ce",
    x: 41.78,
    y: 45.54,
    width: 16.842,
    height: 5.651
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-4bd83080-2f23-40c8-ac71-478aeaba2dca",
    cx: 25.075,
    cy: 125.192,
    rx: 17.102,
    ry: 3.305
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-9cfc8472-3ca2-4ad9-86f1-1b2c15975810",
    d: "M19.986,58.83c-.208,.27-.506,.456-.839,.525-.472,0-.682-.42-1.364-1.102s-1.941-1.312-1.836-1.574,.105-.105,.734-.157,1.521-.157,1.731-.105c.311,.065,.601,.209,.839,.42,.218,.212,.365,.487,.42,.787l.315,1.207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9cfc8472-3ca2-4ad9-86f1-1b2c15975810",
    d: "M9.284,85.532c.134-.651,.383-1.272,.734-1.836l.839,.21,.682,.105c.734,.105,2.151,.262,6.033,.577l.734,.997c.698,1.136,1.211,2.376,1.521,3.672,2.571,10.702,2.78,11.069,2.78,11.069,.367,2.098,.734,4.197,1.049,6.295,.682,4.197,1.574,12.118,2.046,16.158-.087,.283-.251,.537-.472,.734-.233,.167-.503,.275-.787,.315-.944,.157-2.675-5.036-2.675-5.036-1.013-3.433-1.629-6.971-1.836-10.544-.008-.896,.062-1.792,.21-2.675l-3.41-6.453-2.623-5.036c.052,4.039,.052,8.079,0,12.223,0,4.984-.105,9.915-.21,14.794-.132,.127-.295,.218-.472,.262-.297,.063-.605,.045-.892-.052-.441-.143-.838-.396-1.154-.734-.594-3.03-.98-6.098-1.154-9.181-.315-4.354,.105-4.039-.157-7.554-.367-5.351-1.784-12.958-1.416-15.476,.105-.367,.42-1.941,.63-2.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5e83a012-5090-4880-b44d-b4ef790f200c",
    d: "M13.638,63.813c.262-.472,.63-1.102,.367-1.469s-.682-.052-1.941,0-1.941-.262-2.833,0c-.716,.213-1.343,.655-1.784,1.259-.839,1.207-.472,2.728-.367,3.2,.391,1.225,1.211,2.268,2.308,2.938l.997,.577,2.728-4.669,.525-1.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0e17f164-b13e-47a1-9f14-de8c509ace33",
    d: "M10.491,71.997h3.672c-.565-1.306-.694-2.759-.367-4.144l-2.256-.105c-.043,.178-.095,.353-.157,.525-.046,.217-.116,.428-.21,.63-.264,.266-.622,.417-.997,.42l.315,2.675Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9f4b23d1-bcb3-4536-b5c1-7e7ee8655e1b",
    d: "M9.704,103.841v-.21c-.157-2.151-.472-4.616-.787-7.03-.472-3.567-.892-6.977-.63-8.499,.052-.42,.42-2.046,.577-2.938l.315-.892c.113-.368,.272-.721,.472-1.049l.157-.262,.315,.105,.787,.157,.577,.105h.105c.682,.105,2.098,.262,5.98,.577h.21l.105,.157c.262,.337,.507,.687,.734,1.049,.728,1.164,1.26,2.44,1.574,3.777,2.361,9.6,2.728,10.912,2.78,11.069h.052c.157,.892,.262,1.784,.42,2.675-1.154,.944-2.885,1.207-4.616,1.102-.787-1.574-1.626-3.148-2.466-4.721l-1.784-3.515c0,2.623,0,5.194-.052,7.764-1.517,.661-3.196,.862-4.826,.577Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e0139154-8e89-41d0-874d-7c8324459f7b",
    d: "M9.861,90.883c-.597-.731-1.011-1.595-1.207-2.518-.139-1.07-.068-2.157,.21-3.2l.315-.892c.113-.368,.272-.721,.472-1.049l.157-.262,.315,.105,.787,.157,.577,.105h.105c.682,.105,2.098,.262,5.98,.577h.21l.105,.157c.262,.337,.507,.687,.734,1.049,1.364,2.151,1.836,4.931,2.466,7.344s.944,3.672,1.364,5.508c.157,.42,1.364,4.407,.997,4.721s-2.885,1.207-4.616,1.102c-.787-1.574-1.626-3.148-2.466-4.721s-1.836-3.725-3.41-5.246c-1.107-.897-2.142-1.879-3.095-2.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9cfc8472-3ca2-4ad9-86f1-1b2c15975810",
    d: "M13.638,63.813l.472,1.207,1.574,.944c-.105,.262-.262,.472-.367,.682l.157,2.413c-.479,.345-1.01,.611-1.574,.787-.21,.105-.315,.105-2.151,.157-.839,0-1.259,.052-1.416-.21-.206-.295-.226-.682-.052-.997,.105-.262,.262-.262,.42-.525s-.052-.734,.052-1.154,.472-.367,.997-.892,.42-.997,.997-1.679c.248-.3,.55-.549,.892-.734Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-38a93395-3052-4fc2-913f-145c160e80d2",
    d: "M27.173,71.578c-2.712,1.89-5.703,3.341-8.866,4.302,0,1.102,1.784,10.335,2.098,12.066-1.905,.637-3.876,1.06-5.876,1.259-2.248,.264-4.526,.104-6.715-.472-.105-2.361,.315-8.079-.472-11.122-.157-.682-.315-1.312-.525-1.941-.321-1.045,.085-2.177,.997-2.78h.052l.367-.21,.892-.525c1.889-.892,5.351-1.259,5.351-1.259l3.672-.472c1.574-.262,3.043-.525,4.407-.892-.63-1.679-1.312-3.357-2.046-5.089s-1.469-3.41-2.203-5.036l1.836-1.259c1.154,1.836,2.361,3.83,3.567,6.033s2.413,4.879,3.462,7.397Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f122a09c-d39b-4d05-be77-f07a74b9d052",
    d: "M11.225,122.254h2.833c-.052-.472-.052-.997-.105-1.521-.01-.333,.007-.667,.052-.997-.902-.158-1.825-.158-2.728,0,.113,.837,.096,1.687-.052,2.518h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f122a09c-d39b-4d05-be77-f07a74b9d052",
    d: "M23.396,124.352h2.833c0-.525-.472-2.046-.525-2.571l-1.521-.157-1.416-.21c.105,.472,.262,.944,.367,1.469s.157,.997,.262,1.469Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-582e7e55-b3f6-43f6-ad8f-3f5643f7f630",
    "data-name": " Path 6",
    className: "uuid-438bcb12-39f0-4a45-ae73-7af379dd8073",
    d: "M13.481,122.044h0c.052,.052,.21-.42,.42-.525s0,1.049,.944,1.836c.329,.27,.702,.483,1.102,.63,.131,.076,.211,.216,.21,.367v.315h-5.456c0-.896,.159-1.784,.472-2.623h2.308Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-2af5dd14-4ec1-491a-9a5b-08ccfb3d9c45",
    "data-name": " Path 7",
    className: "uuid-438bcb12-39f0-4a45-ae73-7af379dd8073",
    d: "M25.652,124.143h0c.052,.052,.21-.42,.42-.525s1.049,.997,2.256,1.784c.447,.31,.944,.541,1.469,.682,.153,.026,.264,.16,.262,.315v.367h-7.187c0-.896,.159-1.784,.472-2.623h2.308Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "uuid-db82ae0c-686e-42a4-9056-084dda6f1927",
    d: "M118.881,86.84c-.154-.66-.391-1.298-.705-1.898l-.868,.217-.759,.108c-.759,.108-2.224,.271-6.182,.597l-.759,1.03c-.712,1.179-1.242,2.459-1.573,3.796-2.657,11.063-4.664,19.632-5.694,28.96l2.386,.651c.228-.42,.427-.855,.597-1.302,.761-1.723,1.395-3.499,1.898-5.315,1.193-3.742,1.464-4.122,1.681-5.586,.09-.937,.126-1.879,.108-2.82,2.228-2.472,3.861-5.422,4.772-8.623-.163,2.44-.217,4.989-.271,7.593-.045,4.892,.209,9.782,.759,14.643,.25,.155,.526,.265,.813,.325,.312,.046,.63,.008,.922-.108,.488-.163,1.03-.271,1.193-.705,.062-.376-.059-.759-.325-1.03,.885-3.691,1.232-7.49,1.03-11.28,.543-2.091,.977-4.209,1.302-6.345,0,0,.868-6.128,.325-9.979-.163-.759-.542-2.386-.651-2.929Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5e83a012-5090-4880-b44d-b4ef790f200c",
    d: "M96.049,123.718l2.115-.705c2.24-.683,3.873-2.613,4.176-4.935,.054-.38,.325-2.115,.488-2.874,.555-.099,1.121-.117,1.681-.054,.792,.144,1.537,.479,2.169,.976-.478,1.091-.877,2.214-1.193,3.362-.287,1.23-.468,2.482-.542,3.742-.039,.378-.058,.759-.054,1.139h-2.115l-.325-.38-.597,.38h-5.369l-.434-.651Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5e83a012-5090-4880-b44d-b4ef790f200c",
    d: "M117.525,115.746c-1.17-.763-2.68-.763-3.851,0,.143,.551,.234,1.114,.271,1.681,.108,1.247,.542,3.362,.108,3.742l-1.573,1.03-.38,.813c.792-.06,1.587,.051,2.332,.325l.922,.434c.364,.176,.793,.156,1.139-.054,.227-.165,.367-.424,.38-.705l.651-7.267Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-a2ae7cf7-2c43-4b66-b5df-bbaa33c3711f",
    d: "M97.242,61.025l-.271-.976-.651-1.139c-.224-.922-.315-1.872-.271-2.82,.009-.436,.045-.87,.108-1.302l.434-.163,.434-.163h.325c.597,.108,.922,.813,1.085,1.41s-.054,1.03,.325,1.356l.108,.108c.003-.399,.182-.775,.488-1.03l.542-.108c-.06,.118-.097,.247-.108,.38-.125,.46-.198,.933-.217,1.41l-.217,1.356,.163,.976-2.278,.705Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-6b0ee86a-9f5a-40a3-b7e4-e3b6c30f9cff",
    d: "M118.61,73.173h-3.796c.574-1.351,.725-2.845,.434-4.284l2.278-.108c.069,.176,.124,.357,.163,.542,.004,.234,.079,.461,.217,.651,.271,.271,.759,.108,.922,.054l-.217,3.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a2ae7cf7-2c43-4b66-b5df-bbaa33c3711f",
    d: "M115.302,65.364c-.254,.958-.828,1.8-1.627,2.386l.434,.542c.108,.759,.163,1.519,.271,2.278,.493,.261,1.024,.444,1.573,.542,.705,.108,1.627,.271,2.061-.217,.224-.335,.32-.739,.271-1.139-.006-.31-.042-.619-.108-.922-.146-.51-.385-.988-.705-1.41-.341-.579-.782-1.093-1.302-1.519l-.868-.542Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-94151612-2c2d-468d-9072-250cdb79a48a",
    d: "M100.279,73.119c3.138,2.057,6.633,3.51,10.304,4.284-.171,3.133-.811,6.222-1.898,9.165,3.235,1.546,6.933,1.817,10.358,.759-.095-2.779,.309-5.553,1.193-8.189,.467-1.331,1.048-2.619,1.735-3.851-.508-.458-1.052-.876-1.627-1.247l-.38-.271-.922-.488c-1.952-.976-5.477-1.302-5.477-1.302-4.827-.434-4.664-.325-5.64-.488-1.754-.271-3.467-.763-5.098-1.464-1.139-3.417-2.278-6.833-3.362-10.304l-2.712,.705c.434,2.224,.976,4.61,1.681,7.05s1.193,3.905,1.844,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0c3eb26d-7ad6-400a-9f6b-1f5a46848288",
    d: "M121.213,67.75c.813,2.549,3.362,2.386,3.742,4.339s-1.247,4.501-3.362,4.556c-1.193,0-2.386-.922-3.091-2.224-.376,.16-.788,.216-1.193,.163-.662-.209-1.211-.679-1.518-1.302-.705-1.247-.108-3.362,1.41-5.261-1.019-.81-1.898-1.781-2.603-2.874,.587-1.41,2.076-2.222,3.579-1.952,.847,.122,1.63,.523,2.224,1.139,.868,1.085,.325,1.952,.813,3.417Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-5189cdc2-a78a-488a-948f-3050f409d558",
    cx: 107.039,
    cy: 123.592,
    rx: 17.102,
    ry: 3.305
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.fc1a436019a768c29cde83ec90051e6f.svg";
export { ForwardRef as ReactComponent };